import React from "react";
import { Button } from "react-bootstrap";
import classes from "./CustomButtonLightBg.module.css";

const CustomButtonLightBg = (props) => {
  return (
    <Button 
        className={classes.buttonStyle} 
        onClick={props.handleClick}>
        {props.buttonText}
    </Button>
    );
};

export default CustomButtonLightBg;


